module.exports = __webpack_public_path__ + "static/media/contact.d7da9209.svg";